import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";

import { CommonModule } from "@angular/common";

import { DxButtonModule } from "devextreme-angular";
import { AppGlobals } from "../../../app.globals";

@Component({
    selector: "app-landing.page",
    templateUrl: "./landing.page.html",
    styleUrls: ["./landing.page.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterModule, DxButtonModule]
})
export class LandingPage {
  currentPageTitle: string = "Dashboard";

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appGlobals: AppGlobals
  ) {}

  ngOnInit(): void {
    this.appGlobals.$headerTitle.next($localize`${this.currentPageTitle}`);
  }

  ngAfterContentInit(): void {
    this.activateFocusedButton();
  }

  logoutFromTopNavigation(): void {
    this.router.navigate(["logout"]);
  }

  activateFocusedButton(): void {
    this.appGlobals.activateTopNavButton();
  }

  userIsLoggedIn(): boolean {
    return AppGlobals.LoggedIn;
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }
}
